var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36359 12.9999C7.8458 12.9999 8.30826 12.8054 8.64924 12.4592C8.99022 12.113 9.18177 11.6434 9.18177 11.1538C9.18177 10.6641 8.99022 10.1946 8.64924 9.84834C8.30826 9.50212 7.8458 9.30762 7.36359 9.30762C6.88138 9.30762 6.41892 9.50212 6.07794 9.84834C5.73697 10.1946 5.54541 10.6641 5.54541 11.1538C5.54541 11.6434 5.73697 12.113 6.07794 12.4592C6.41892 12.8054 6.88138 12.9999 7.36359 12.9999V12.9999ZM16.4545 12.9999C16.9367 12.9999 17.3992 12.8054 17.7401 12.4592C18.0811 12.113 18.2727 11.6434 18.2727 11.1538C18.2727 10.6641 18.0811 10.1946 17.7401 9.84834C17.3992 9.50212 16.9367 9.30762 16.4545 9.30762C15.9723 9.30762 15.5098 9.50212 15.1689 9.84834C14.8279 10.1946 14.6363 10.6641 14.6363 11.1538C14.6363 11.6434 14.8279 12.113 15.1689 12.4592C15.5098 12.8054 15.9723 12.9999 16.4545 12.9999V12.9999Z",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22727 11.1538H13.7273V1.55385C13.7273 1.40696 13.6698 1.26608 13.5675 1.16222C13.4652 1.05835 13.3265 1 13.1818 1H1M5.22727 11.1538H3.36364C3.29201 11.1538 3.22108 11.1395 3.1549 11.1117C3.08872 11.0839 3.02859 11.0431 2.97794 10.9916C2.92729 10.9402 2.88711 10.8791 2.8597 10.8119C2.83229 10.7448 2.81818 10.6727 2.81818 10.6V6.07692",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90918 3.76953H5.54554",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7273 3.76953H18.8273C18.9327 3.76956 19.0359 3.80061 19.1243 3.85893C19.2127 3.91725 19.2826 4.00034 19.3255 4.09815L20.9527 7.8163C20.9838 7.8869 20.9999 7.96331 21 8.04061V10.6003C21 10.673 20.9859 10.7451 20.9585 10.8122C20.9311 10.8794 20.8909 10.9405 20.8403 10.9919C20.7896 11.0434 20.7295 11.0842 20.6633 11.112C20.5971 11.1398 20.5262 11.1541 20.4546 11.1541H18.7273M13.7273 11.1541H14.6364",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/Delivery.f2ded4811c350f0b83b53adeb1cad285.svg";
export { ForwardRef as ReactComponent };